import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=206c07e6&scoped=true&"
import script from "./Agenda.vue?vue&type=script&lang=js&"
export * from "./Agenda.vue?vue&type=script&lang=js&"
import style0 from "./Agenda.vue?vue&type=style&index=0&id=206c07e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c07e6",
  null
  
)

export default component.exports